import { render, staticRenderFns } from "./ForeignExports.vue?vue&type=template&id=f00ef9b4&scoped=true"
import script from "./ForeignExports.vue?vue&type=script&lang=js"
export * from "./ForeignExports.vue?vue&type=script&lang=js"
import style0 from "./ForeignExports.vue?vue&type=style&index=0&id=f00ef9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00ef9b4",
  null
  
)

export default component.exports